var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row align-items-center"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"page-title-box"},[_c('h3',{staticClass:"font-size-21"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"page-title-right"},[_c('b-breadcrumb',{staticClass:"m-0",attrs:{"items":_vm.items}})],1)])]),_c('div',{staticClass:"col-sm-6"})])
}
var staticRenderFns = []

export { render, staticRenderFns }